package com.karawek.core.ui.haptics

fun performHapticIfEnabled(
    enabled: Boolean,
    type: HapticType,
) {
    if (!enabled) return
    CoreHaptics.perform(type)
}